<template>
  <div>
    <video-landscape :detail="detail" v-if="parames.screenMode == 'true'"/>
    <video-portraitscreen :detail="detail" v-else/>
  </div>
</template>

<script>
import videoLandscape from './components/video-landscape'
import videoPortraitscreen from './components/video-portraitscreen'
export default {
  components: {
    videoLandscape,
    videoPortraitscreen
  },
  data() {
    return {
      detail: {}
    };
  },
  computed: {
    parames() {
      return this.$route.query;
    },
  },
  methods: {
    queryDocumentDetail() {
      const { id, searchKey, sequenceNumber } = this.parames;
      this.$api.help
        .queryDocumentDetail({ id, searchKey, sequenceNumber })
        .then((res) => {
          this.detail = res.data;
        });
    },
  },
  mounted() {
    this.queryDocumentDetail();
  },
};
</script>

<style lang="stylus" scoped>
body {
  margin: 0;
  padding: 0;
}
</style>
